// This is taken from here: https://highcharts.uservoice.com/forums/55896-general/suggestions/3073133-pie-title

/**
* Pie title plugin
* Last revision: 2015-5-20
*/
export default function (Highcharts) {
  Highcharts.wrap(Highcharts.seriesTypes.pie.prototype, 'render', function (proceed) {

    var chart = this.chart,
      center = this.center || (this.yAxis && this.yAxis.center),
      titleOption = this.options.title,
      box;

    proceed.call(this);

    if (center && titleOption) {
      box = {
        x: chart.plotLeft + center[0] - 0.5 * center[2],
        y: chart.plotTop + center[1] - 0.5 * center[2],
        width: center[2],
        height: center[2]
      };

      if (!this.title) {
        this.title = this.chart.renderer.label(titleOption.text)
          .css(titleOption.style)
          .add();
      }
      
      var labelBBox = this.title.getBBox();

      if (titleOption.align == 'center') {
        box.x -= labelBBox.width/2;
      } else if (titleOption.align == 'right') {
        box.x -= labelBBox.width;
      }

      this.title.align(titleOption, null, box);
    }
  });

};